import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, FONT } from "../shared/styles";

function DomainBanner({ sx = {} }) {
  return (
    <Box
      sx={{
        px: "16px",
        py: "12px",
        borderRadius: "8px",
        border: "1px solid #FCD34D",
        bgcolor: "#FFFBEB",
        ...sx,
      }}
    >
      <Typography
        sx={{
          color: "#92400E",
          fontFamily: FONT.family,
          fontSize: "13px",
          fontWeight: 400,
          lineHeight: "20px",
        }}
      >
        Verify your company domain for the selected group before linking an email. The address must belong to that verified domain.
      </Typography>
    </Box>
  );
}

export default DomainBanner;
